import type { ListBuilderList } from '../../../types';
import { createNearMeColumns } from '../columns';
import {
	CLIENT_MOBILE_CARD_CONFIG,
	DEFAULT_LIST_REQUIRED_FIELDS,
	createClientKanbanConfig,
} from '../shared';

/**
 * Near Me list configuration
 * Clients within 25 miles of current location, sorted by distance
 */
export const defaultClientsNearMeList: ListBuilderList = {
	id: 'default-clients-near-me',
	cacheTTL: 60000,
	name: 'Near Me (25mi)',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	defaultSortId: 'column-proximity-asc',
	filterRules: {
		nearMe: {
			defaultValue: [
				{
					id: 'me:25',
					label: 'Me (Current Location) - 25 miles',
					data: {
						centerType: 'me',
						radius: 25,
					},
				},
			],
		},
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
				},
			],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
	},
	columns: createNearMeColumns(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description:
		'Clients within 25 miles of current location, sorted by distance',
	requiredFields: [
		...DEFAULT_LIST_REQUIRED_FIELDS,
		// PD-13545 — the backend's computed distance alias. clients.service.ts
		// SELECTs `… AS proximity` and excludes `client.proximity` from the field
		// list, so this is safe on every near-me request (even when geolocation is
		// denied and the filter itself drops). The old `client.distanceFromCenter`
		// was neither a column nor an alias → it leaked into the SELECT and
		// produced "Unknown column 'client.distanceFromCenter'".
		'client.proximity',
	],
	sortOrder: 7,
	kanbanConfig: createClientKanbanConfig(),
};
